import type { CountryCode } from 'libphonenumber-js'

import { createPhoneNumberUtils, PhoneNumberUtils } from './phoneNumberUtils'

export interface PhoneNumberConfig {
  country?: CountryCode
}

export const usePhoneNumber = ({ country }: PhoneNumberConfig): PhoneNumberUtils => {
  return createPhoneNumberUtils(country)
}
